export const SIGNATURE_LOGO_PATH = "/brand/email-signature-icon.png";
export const SIGNATURE_LOGO_PROD_URL = `https://platebuddies.com${SIGNATURE_LOGO_PATH}`;

export const SIGNATURE_TAGLINE = "Where Every Meal Has a Story";
const WEBSITE = "www.platebuddies.com";
const WEBSITE_HREF = "https://www.platebuddies.com";

export const EMPTY_DETAILS = { name: "", title: "", phone: "", email: "" };
export const SAMPLE_DETAILS = {
  name: "Your Name",
  title: "Your Title",
  phone: "000-000-0000",
  email: "you@platebuddies.com",
};

const FONT = "font-family:'Baloo 2','Trebuchet MS',Verdana,sans-serif;";
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const esc = (s) =>
  String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const phoneHref = (phone) => {
  const digits = phone.replace(/\D/g, "");
  return `tel:+${digits.length === 10 ? `1${digits}` : digits}`;
};

export const withSamples = (d) =>
  Object.fromEntries(Object.keys(SAMPLE_DETAILS).map((k) => [k, d[k].trim() || SAMPLE_DETAILS[k]]));

export const isComplete = (d) =>
  Boolean(d.name.trim() && d.title.trim() && d.phone.replace(/\D/g, "").length >= 7 && EMAIL_RE.test(d.email.trim()));

export function buildSignatureHtml(d, logoUrl = SIGNATURE_LOGO_PROD_URL) {
  const line = (inner, style) => `<tr><td style="${FONT}${style}">${inner}</td></tr>`;
  const link = (href, text, color, bold = false) =>
    `<a href="${esc(href)}" style="${FONT}color:${color};text-decoration:none;${bold ? "font-weight:700;" : ""}">${esc(text)}</a>`;
  const email = d.email.trim();

  return `<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse:collapse;${FONT}">
<tr>
<td valign="middle" style="padding:0 18px 0 0;vertical-align:middle;"><a href="${WEBSITE_HREF}" style="text-decoration:none;"><img src="${logoUrl}" width="104" height="95" alt="Plate Buddies" style="display:block;width:104px;height:95px;border:0;outline:none;"></a></td>
<td width="4" bgcolor="#F26A34" style="width:4px;min-width:4px;background-color:#F26A34;border-radius:2px;font-size:1px;line-height:1px;">&nbsp;</td>
<td valign="middle" style="padding:0 0 0 18px;vertical-align:middle;">
<table cellpadding="0" cellspacing="0" border="0" role="presentation" style="border-collapse:collapse;">
${line(esc(d.name.trim()), "font-size:22px;font-weight:700;color:#4E2C80;line-height:1.15;")}
${line(esc(d.title.trim().toUpperCase()), "font-size:13px;font-weight:700;letter-spacing:2px;color:#06A5A1;padding:2px 0 8px 0;")}
${line(link(phoneHref(d.phone), d.phone.trim(), "#1C1628"), "font-size:15px;color:#1C1628;line-height:1.5;")}
${line(link(`mailto:${email}`, email, "#1C1628"), "font-size:15px;color:#1C1628;line-height:1.5;")}
${line(link(WEBSITE_HREF, WEBSITE, "#F26A34", true), "font-size:15px;font-weight:700;color:#F26A34;line-height:1.5;")}
${line(SIGNATURE_TAGLINE, "font-size:13px;font-style:italic;color:#4E2C80;line-height:1.4;padding:4px 0 0 0;")}
</table>
</td>
</tr>
</table>`;
}

export function buildSignatureText(d) {
  return [d.name, d.title, d.phone, d.email, WEBSITE, SIGNATURE_TAGLINE].map((s) => s.trim()).join("\n");
}

function legacyCopy(html, text) {
  const onCopy = (e) => {
    e.clipboardData.setData("text/html", html);
    e.clipboardData.setData("text/plain", text);
    e.preventDefault();
  };
  document.addEventListener("copy", onCopy);
  const ok = document.execCommand("copy");
  document.removeEventListener("copy", onCopy);
  if (!ok) throw new Error("Copy was blocked by the browser");
}

export async function copySignature(html, text) {
  if (navigator.clipboard?.write && typeof window.ClipboardItem !== "undefined") {
    try {
      await navigator.clipboard.write([
        new window.ClipboardItem({
          "text/html": new Blob([html], { type: "text/html" }),
          "text/plain": new Blob([text], { type: "text/plain" }),
        }),
      ]);
      return;
    } catch (_) {
      // fall through to the legacy copy path
    }
  }
  legacyCopy(html, text);
}
